'use client';

import { AgencySchema } from '@ametista-ai/api-schema';
import { Avatar, AvatarProps } from '@mantine/core';
import { getAgencyImageUrl } from '@/utils/file';

export function AgencyAvatar({
  agency,
  size = 'sm',
}: {
  agency: AgencySchema | null | undefined;
  size?: AvatarProps['size'];
}) {
  if (agency?.image) {
    return (
      <Avatar
        size={size}
        radius="lg"
        src={getAgencyImageUrl(agency.id, `?v=${agency.image}`)}
        name={agency.name}
        color="initials"
      />
    );
  }

  return (
    <Avatar size={size} radius="lg" src={agency?.image} name={agency?.name} color="initials" />
  );
}
